/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Senth Vyra",
  logo_name: "Senth Vyra",
  nickname: "senth / picleric",
  full_name: "Senthalan Vyravanathan",
  subTitle: "Full Stack Developer, Co-Founder at Habb 🔥.   Always learning.",
  // resumeLink:
  //   "https://drive.google.com/file/d/1NQugCN-EtZs3haRtbgFGxgSaF5Xr8SzA/view?usp=drivesdk",
  mail: "SenthVyra@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/SenthVyra",
  linkedin: "https://www.linkedin.com/in/SenthVyra/",
  gmail: "SenthVyra@gmail.com",
  // gitlab: "https://gitlab.com/SenthVyra",
  facebook: "https://www.facebook.com/SenthVyra/",
  twitter: "https://twitter.com/SenthVyra",
  instagram: "https://www.instagram.com/SenthVyra/",
  whatsapp: "https://wa.me/94701111055",
  youtube: "https://www.youtube.com/@Senth",
  
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications",
        "⚡ Creating application backend ",
        "⚡ Integration of third party services ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "ElectronJS",
          fontAwesomeClassname: "simple-icons:electron",
          style: {
            color: "#47848F",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon-plain:java-wordmark",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sri Lanka Institute of Information Technology",
      subtitle: "B.Sc. (Hons) in Information Technology",
      logo_path: "sliit2.png",
      alt_name: "SLIIT",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ Specialized in core areas such as Machine Learning, Computer Vision, and Advanced Web Development.",
        "⚡ Built multiple academic and personal projects applying theoretical knowledge into real-world solutions.",
        "⚡ Actively participated in several national-level hackathons and secured winning positions in more than 5 competitions.",
      ],
      website_link: "http://www.sliit.lk/",
    },
    {
      title: "Kn/ Pallai Central College",
      subtitle: "G.C.E Advanced Level – Biological Science Stream",
      logo_path: "pcc.jpg",
      alt_name: "PCC",
      duration: "2016 - 2019",
      descriptions: [
        "⚡ Studied core subjects including Biology, Physics, and Chemistry.",
        "⚡ Participated in various school-level competitions and extracurricular activities.",
        "⚡ Maintained strong academic performance throughout the A/L period.",
      ],
      website_link: "https://www.facebook.com/pallaicc/",
    },
  {
    title: "Jaffna Hindu College",
    subtitle: " Secondary Education",
    logo_path: "jhc_logo.png",
    alt_name: "JHC",
    duration: "2010 - 2015",
    descriptions: [
      "⚡ Built a strong academic foundation in Mathematics, Science, and English during O/L years.",
      "⚡ Represented the school in various district-level competitions, including science exhibitions and quiz programs.",
      "⚡ Excelled in leadership roles and cultural events, actively contributing to school life beyond the classroom.",
    ],
    website_link: "http://www.jhc.lk/"
  }
  ],  

};


const certifications = {
  certifications: [
    {
      title: "MongoDB Basics",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://www.linkedin.com/in/senthvyra/",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },
        {
      title: "Responsible AI",
      subtitle: "Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.linkedin.com/in/senthvyra/",
      alt_name: "Google",
      color_code: "#fe0037",
    },
    {
          title: "LinkedIn Learning",
      subtitle: "LinkedIn",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/in/senthvyra/",
      alt_name: "Linkedin",
      color_code: "#2AAFED",
    },
    // {
    //   title: "M0001: MongoDB Basics",
    //   subtitle: "MongoDB University",
    //   logo_path: "mongo.png",
    //   certificate_link:
    //     "https://www.linkedin.com/in/senthvyra/",
    //   alt_name: "MongoDB University",
    //   // color_code: "#2AAFED",
    //   color_code: "#47A048",
    // },
    // {
    //   title: "Hackathon",
    //   subtitle: "Hack The Mountains",
    //   logo_path: "hackathon1.svg",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1Y-HT1flWDfeyfnfqVr3ubNgGIcnuUEYt/view?usp=sThulaxng",
    //   alt_name: "hackathon",
    //   color_code: "#E2405F",
    // },
    // {
    //   title: "A300: Atlas Security",
    //   subtitle: "MongoDB University",
    //   logo_path: "mongo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/12u_tkvhgB-K2TIm-RDdJOwYbQ9ccqiqA/view?usp=sThulaxng",
    //   alt_name: "MongoDB University",
    //   // color_code: "#F6B808",
    //   color_code: "#47A048",
    // },
    // {
    //   title: "Cyber Security & Cyber Forensics",
    //   subtitle: "Workshop at IIT Bombay",
    //   logo_path: "iit.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/12uAdjQC5LfrB1ODdxqIY181ugyyQhl-I/view?usp=sThulaxng",
    //   alt_name: "Workshop",
    //   color_code: "#2AAFED",
    // },
    // {
    //   title: "MLH Local Hack Day: Build",
    //   subtitle: "Major League Hacking",
    //   logo_path: "mlh-logo.svg",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1ws7g2Oepu76vDFir6SvR_emFAMSkB2ZQ/view?usp=sThulaxng",
    //   alt_name: "Google",
    //   color_code: "#fe0037",
    // },
    // {
    //   title: "Hack20",
    //   subtitle: "Flutter International Hackathon",
    //   logo_path: "flutter.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1JTd8pVlHbP0RVQYtfa4OZgJYGfdiCwM6/view?usp=sThulaxng",
    //   alt_name: "Flutter International Hackathon",
    //   color_code: "#2AAFED",
    // },
    // {
    //   title: "Postman Student Expert",
    //   subtitle: "Postman",
    //   logo_path: "postman.png",
    //   certificate_link:
    //     "https://badgr.com/public/assertions/h2qevHs4SlyoHErJQ0mn2g",
    //   alt_name: "Postman",
    //   // color_code: "#f36c3d",
    //   color_code: "#fffbf3",
    // },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page - Senthalan Vyravanathan
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "As a passionate Software Engineer, I have hands-on experience working in real-world projects ranging from ERP systems to healthcare apps. I've contributed to both frontend and backend development using technologies like MERN, Laravel, .NET, and Firebase. I enjoy learning new tools, collaborating in teams, and building meaningful digital solutions.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Software Engineer",
          company: "Habb (Pvt) Ltd.",
          company_url: "",
          logo_path: "habb.png",
          duration: "March 2025 - Present",
          location: "Sri Lanka",
          description: `
Worked within Agile sprints using GitHub and improved communication and time management through daily standups.`,
          color: "#0071C5",
        },
        {
          title: "Software Engineer",
          company: "Bohar Solutions (Pvt) Ltd.",
          company_url: "https://www.bohar.lk",
          logo_path: "bohar.webp",
          duration: "October 2023 – February 2025",
          location: "Jaffna, Sri Lanka",
          description: `31st December 2024, promoted to Software Engineer (On-site) until 28th February 2025.
          
        Contributed to multiple projects including Digital Marketing Solutions, Waste Management System and Lead Management System etc.

        Worked closely with cross-functional teams and maintained high professional standards.`,
          color: "#E96A0C",
        },
  
        {
          title: "Associate Software Engineer",
          company: "Bohar Solutions (Pvt) Ltd.",
          company_url: "https://bohar.lk/",
          logo_path: "bohar.webp",
          duration: "October 2023 – December 2024",
          location: "Jaffna, Sri Lanka",
          description: `        
        Started as an Associate Software Engineer (Hybrid) from 2nd October 2023, Demonstrated strong technical expertise, problem-solving, and consistent work ethic.`,
          color: "#FF5733",
        },
        {
          title: "Software Engineering Intern",
          company: "EWIS Career Training (Pvt) Ltd.",
          company_url: "https://www.ectc.lk",
          logo_path: "ewis.png",
          duration: "March 2023 – September 2023",
          location: "Sri Lanka",
          description: `Successfully completed a 6-month internship under the Research & Development Department.
        
        Actively contributed to the development of ECTC Lecture Payment System, ECTC Human Resource Management System and Akari System
        
       Recognized as a hardworking and responsible intern who fulfilled tasks with diligence and commitment.`,
          color: "#1B3A57",
        },
        
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Research Contributor (IEEE)",
          company: "IEEE",
          company_url: "https://ieeexplore.ieee.org/document/10698527",
          logo_path: "ieee.png",
          duration: "2024",
          location: "Sri Lanka",
          description: `Published research on Tamil spelling and grammar correction using Seq2Seq and Transformer models. 
Used frameworks like TensorFlow and Flask to build the model backend and UI.`,
          color: "#00369f",
        },
        {
          title: "Open Source Contributor",
          company: "GitHub",
          company_url: "https://github.com/SenthVyra",
          logo_path: "github.png",
          duration: "Ongoing",
          location: "Remote",
          description: `Contributed to full-stack projects such as e-commerce platforms, hospital systems, and management dashboards. 
Worked with ASP.NET Core, React, Laravel, and Java-based web systems.`,
          color: "#333333",
        },
      ],
    },
  ],
};

// Experience Page
// const experience = {
//   title: "Experience",
//   subtitle: "Work, Internship and Volunteership",
//   description:
//     "As a Node.js Full Stack Developer, I have worked with real projects for over two years. I've mostly done projects on my own. I love organizing workshops to share my knowledge with others.",
//   header_image_path: "experience.svg",
//   sections: [
//     {
//       title: "Work Experience",
//       experiences: [
//         {
//           title: "Software Engineer",
//           company: "Crest Infosystems Pvt. Ltd.",
//           company_url: "https://www.crestinfosystems.com/",
//           logo_path: "crest.png",
//           duration: "Jan 2024 - Present",
//           location: "Surat, Gujarat",
//           description: `Worked on enterprise-level software solutions including employee
// activity tracking system, point of sale system and support ticket
// systems, utilizing full-stack technologies and custom integrations. Improved system efficiency and user experience across
// multiple projects by developing and maintaining full-stack web apps
// with modern technologies like Electron.js, React.js, Node.js, and
// Sequelize. Designed and implemented custom solutions for tracking employee
// activity and database optimizations, resulting in improvement in
// performance.`,
//           color: "#0071C5",
//         },
        // {
        //   title: "Node.js Full Stack Developer",
        //   company: "Valora Infotech",
        //   company_url: "http://valorainfotech.com/",
        //   logo_path: "valora.jpg",
        //   duration: "Oct 2020 - Dec 2022",
        //   location: "Surat, Gujarat",
        //   description: `Train, oversee, and mentor young software development employees. I created and managed the admin panel backend and a gambling application as a Node.js Full Stack Developer. I obtained knowledge in Web Socket, Payment Gateway Integration, and gaming legislation, while growing my industry experience and investigating new technologies.
        //   Focus on change request functions in close collaboration with the project manager and team leads.
        //   Developed new and maintained existing applications.
        //   Increased productivity and problem-solving technics by 20%.
        //   We primarily used PERN and MERN Stack. 80% of my work was doing backend development and the remaining 20% was DevOps-related tasks.
        //   `,
        //   // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
        //   color: "#0071C5",
        // },
        // {
        //   title: "Node.js Full Stack Developer (Intern)",
        //   company: "Valora Infotech",
        //   company_url: "http://valorainfotech.com/",
        //   logo_path: "valora.jpg",
        //   duration: "Oct 2020 - Mar 2021",
        //   location: "Surat, Gujarat",
        //   description: `Focus on change request functions in close collaboration with the project manager and team leads.
        //   Developed new and maintained existing applications.
        //   Increased productivity and problem-solving technics by 20%.
        //   We primarily used PERN and MERN Stack. 80% of my work was doing backend development and the remaining 20% was DevOps-related tasks.
        //   `,
        //   // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
        //   color: "#0071C5",
        // },
    //     {
    //       title: "Full Stack Developer (Freelancer)",
    //       company: "NightOwls",
    //       company_url: "http://nightowls.company/",
    //       logo_path: "nightowls.jpg",
    //       duration: "Sep 2020 - Oct 2020",
    //       location: "Work From Home",
    //       description: `Maintain close contact with the client and team when handling change requests.
    //       LAMP Stack was mostly utilised. 40% of my work was doing backend development, 30% of my work was designing database schemas, and 30% of my work was on maintain hosting and user traffics on the website.
    //       `,
    //       // "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
    //       color: "#ee3c26",
    //     },
    //   ],
    // },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Community Lead",
    //       company: "Bauddhik-Geeks",
    //       company_url: "https://bauddhikgeeks.tech/",
    //       logo_path: "bauddhikgeeks.png",
    //       duration: "Sep 2021 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Help Tech-Geeks so they get exposure to the technical world and enlighten their skills. Hence, the programming club highlight all the skills of the individual members and help them develop and groom their skills in a meaningful way. Help community members to learn and grow.",
    //       color: "#FBBD18",
    //     },
    //     {
    //       title: "Cross Winter of Code Mentor",
    //       company: "CWOC",
    //       company_url: "https://crosswoc.ieeedtu.in/",
    //       logo_path: "cwoc.png",
    //       duration: "Feb 2021 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
    //       color: "#4285F4",
    //     },
        // {
        //   title: "Campus Hustler",
        //   company: "Skillenza",
        //   company_url: "https://skillenza.com/",
        //   logo_path: "skillenza.png",
        //   duration: "Feb 2021 - Present",
        //   location: "Work from Home",
        //   description:
        //     "Spread Awareness of new Technologies and new Opportunities to Students and Grow Skillenza Community.",
        //   color: "#196acf",
        // },
//         {
//           title: "GDG Student Volunteer",
//           company: "Google Developer Groups",
//           company_url: "https://gdg.community.dev/",
//           logo_path: "gdg.png",
//           duration: "Feb 2021 - Present",
//           location: "Work From Home",
//           description:
//             "Google Developer Group Surat Student Volunteer and Member.",
//           color: "#D83B01",
//         },
//         {
//           title: "Postman Student Expert",
//           company: "Postman",
//           company_url: "https://www.postman.com/",
//           logo_path: "postman.png",
//           duration: "Feb 2020 - Present",
//           location: "Work From Home",
//           description:
//             "Google Developer Group Surat Student Volunteer and Member.",
//           color: "#D83B01",
//         },
//         {
//           title: "GitHub Student Developer",
//           company: "GitHub",
//           company_url: "https://github.com/",
//           logo_path: "github.png",
//           duration: "Nov 2019 - Present",
//           location: "Work from Home",
//           description:
//             "Contribute to Open Source Community and Open Source Project.",
//           color: "#040f26",
//         },
//         {
//           title: "Google Local Guide",
//           company: "Google Map",
//           company_url: "https://maps.google.com/localguides/",
//           logo_path: "localguide.png",
//           duration: "Sep 2018 - Present",
//           location: "Work From Home",
//           description:
//             "Day-to-day responsibilities of helping local businesses to spread their business to the world. Helping users by writing reviews about different locations and spaces such as shops, malls, etc.",
//           color: "#D83B01",
//         },
//         {
//           title: "E. F. I. Student Volunteer",
//           company: "ENVIRONMENTALIST FOUNDATION OF INDIA",
//           company_url: "https://indiaenvironment.org/",
//           logo_path: "efi.png",
//           duration: "Apr 2017 - Present",
//           location: "Work From Home",
//           description:
//             "Take time out over weekends to join a gang of nation builders, nature enthusiasts to conserve what is left.",
//           color: "#5a900f",
//         },
//       ],
//     },
//   ],
// };

// Projects Page
  const projectsHeader = {
    title: "Projects",
    description:
      "These are not just lines of code — they’re a reflection of my journey, skill growth, and passion to solve real-world problems. I enjoy building full-stack web apps, smart systems, and AI-powered tools. Most of my work uses modern stacks like MERN, .NET Core, Python, and more. Below are some highlighted projects — and yep, more are coming!",
    avatar_image_path: "projects_image.svg",
  };
  

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "senthalan_croped.png",
    description:
      "I'm just a message away. Whether it’s about tech, collabs, or just a good convo — feel free to connect! I’ll do my best to respond quickly.",
  },
  blogSection: {
    title: "Blogs & Thoughts",
    subtitle:
      "I occasionally share my thoughts, career tips, and tech insights on LinkedIn. I believe in giving back by documenting what I learn.",
    link: "https://linkedin.com/in/senthvyra",
    avatar_image_path: "blogs_image.svg",
  },
};


const projects = {
  data: [
    {
      id: "0",
      name: "Quiz App",
      url: "https://github.com/senthvyra",
      description: "An interactive quiz application developed using C#.",
      languages: [
        { name: "C#", iconifyClass: "logos:c-sharp" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "1",
      name: "Employee Management System",
      url: "https://github.com/senthvyra/EmployeeManagement",
      description: "A comprehensive system to manage employee data using ASP.NET Core MVC and SQL.",
      languages: [
        { name: "C#", iconifyClass: "logos:c-sharp" },
        { name: "ASP.NET Core", iconifyClass: "logos:dotnet" },
        { name: "SQL", iconifyClass: "logos:mysql" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "2",
      name: "Pokemon Review API",
      url: "https://github.com/senthvyra",
      description: "A RESTful API for managing Pokémon reviews, built with ASP.NET Core.",
      languages: [
        { name: "C#", iconifyClass: "logos:c-sharp" },
        { name: "ASP.NET Core", iconifyClass: "logos:dotnet" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "3",
      name: "GridView Total Calculator",
      url: "https://github.com/senthvyra",
      description: "A tool to calculate totals in a GridView using ASP.NET and jQuery.",
      languages: [
        { name: "ASP.NET", iconifyClass: "logos:dotnet" },
        { name: "jQuery", iconifyClass: "logos:jquery" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "4",
      name: "Tamil Typing Assistant (NLP Research)",
      url: "https://ieeexplore.ieee.org/document/10698527",
      description: "An NLP tool to assist with Tamil typing, including spell checking and text summarization. Published in IEEE ICECET 2024.",
      languages: [
        { name: "Python", iconifyClass: "logos:python" },
        { name: "NLP", iconifyClass: "logos:nlp" },
      ],
      links: [
        { name: "IEEE", url: "https://ieeexplore.ieee.org/document/10698527", iconifyClass: "ri:external-link-line" },
        { name: "GitHub", url: "https://lnkd.in/gXVCPQbp", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "5",
      name: "SvelteKit Trading App",
      url: "https://github.com/senthvyra",
      description: "A trading application built with SvelteKit, featuring SSR and Tailwind CSS integration.",
      languages: [
        { name: "TypeScript", iconifyClass: "logos:typescript" },
        { name: "Svelte", iconifyClass: "logos:svelte" },
        { name: "Tailwind CSS", iconifyClass: "logos:tailwindcss" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "6",
      name: "Online Music Store",
      url: "https://github.com/senthvyra/OOP_Y2S1",
      description: "An online platform for music sales, developed as part of an academic project.",
      languages: [
        { name: "Java", iconifyClass: "logos:java" },
        { name: "CSS", iconifyClass: "logos:css3" },
        { name: "HTML", iconifyClass: "logos:html5" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/senthvyra/OOP_Y2S1", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "7",
      name: "Employee Social Media",
      url: "https://github.com/SenthVyra/Employee_Social_Media",
      description: "A social media platform designed for employees to connect, communicate, and collaborate effectively.",
      languages: [
        { name: "MERN", iconifyClass: "logos:mongodb" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/SenthVyra/Employee_Social_Media", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "8",
      name: "Supermarket Management System",
      url: "https://github.com/SenthVyra/ITP_Y2S2",
      description: "A Java-based system that manages inventory, sales, and transactions in supermarkets.",
      languages: [
        { name: "Java", iconifyClass: "logos:java" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/SenthVyra/ITP_Y2S2", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "9",
      name: "Food Stock Management Mobile App",
      url: "https://github.com/SenthVyra/MAD_Y2S2",
      description: "A mobile application for monitoring food stock levels, ensuring optimized inventory management.",
      languages: [
        { name: "Java", iconifyClass: "logos:java" },
        { name: "Android", iconifyClass: "logos:android-icon" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/SenthVyra/MAD_Y2S2", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "10",
      name: "Recycle App",
      url: "https://github.com/SenthVyra/ITPM_Y3S2",
      description: "A MERN stack web app promoting sustainable recycling practices by connecting users with recycling centers.",
      languages: [
        { name: "MERN", iconifyClass: "logos:mongodb" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/SenthVyra/ITPM_Y3S2", iconifyClass: "ri:github-fill" },
      ],
    },
    {
      id: "11",
      name: "E-commerce App",
      url: "https://github.com/SenthVyra/Ecommerce-App",
      description: "An advanced e-commerce platform built using Laravel 11 and Livewire 3 for seamless online shopping experiences.",
      languages: [
        { name: "PHP", iconifyClass: "logos:php" },
        { name: "Laravel", iconifyClass: "logos:laravel" },
      ],
      links: [
        { name: "GitHub", url: "https://github.com/SenthVyra/Ecommerce-App", iconifyClass: "ri:github-fill" },
      ],
    },
  ],
};


// const projects = {
//   data: [
//     {
//       id: "0",
//       name: "Keep Calm and Carry On",
//       url: "https://github.com/SenthVyra",
//       description:
//         "This platform enables users to practice Augmented Reality meditation, play stress burster games, track task completion and engage in motivational exercises to cope with stress and anxiety at work.  ",
//       languages: [
//         {
//           name: "HTML5",
//           iconifyClass: "logos-html-5",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "logos-css-3",
//         },
//         {
//           name: "NodeJs",
//           iconifyClass: "logos-nodejs",
//         },
//         {
//           name: "Augmented Reality",
//           iconifyClass: "bi:badge-ar",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/Keep-Calm-and-Carry-On.github.io",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devpost",
//           url: "https://devpost.com/software/keep-calm-and-carry-on",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//         {
//           name: "Live Demo",
//           url:
//             "https://akshitagupta15june.github.io/Keep-Calm-and-Carry-On.github.io/",
//           iconifyClass: "mdi:web",
//         },
//       ],
//     },
//     {
//       id: "1",
//       name: "YOG4LIFE SOCIAL APP",
//       url: "https://github.com/kevalvavaliya/Yog4Life",
//       description:
//         "An app for helping people their healthy life. Yog4Life Has a feed feature which is help to get information from the folks, Yog4Life has an anonymous chat room to get connected with the world.",
//       languages: [
//         {
//           name: "Flutter",
//           iconifyClass: "logos-flutter",
//         },
//         {
//           name: "NodeJs",
//           iconifyClass: "logos-nodejs",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/kevalvavaliya/Yog4Life",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devfolio",
//           url: "https://devfolio.co/projects/yoglife-b20d",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//       ],
//     },
//     {
//       id: "2",
//       name: "Adoptisity",
//       url: "https://github.com/kevalvavaliya/Adoptisity",
//       description:
//         "Our mission is to spread awareness about the benefits of adoption and to support LGBT families so that everyone has the chance to have a loving home environment.",
//       languages: [
//         {
//           name: "HTML5",
//           iconifyClass: "logos-html-5",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "logos-css-3",
//         },
//         {
//           name: "JavaScript",
//           iconifyClass: "logos-javascript",
//         },
//         {
//           name: "Wix",
//           iconifyClass: "bxl:wix",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/Adoptisity",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devpost",
//           url: "https://devpost.com/software/adoptisity",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//         {
//           name: "Live Demo",
//           url: "https://rajmahadevwala1.wixsite.com/adoptisity",
//           iconifyClass: "mdi:web",
//         },
//       ],
//     },
//     {
//       id: "3",
//       name: "FinSplit",
//       url: "https://github.com/rajmahadev8/Fin-Split",
//       description:
//         "Split your bills with your friends without any hassle. Manage Group Expenses, Track your expenses, and much more.",
//       languages: [
//         {
//           name: "ReactJS",
//           iconifyClass: "logos-react",
//         },
//         {
//           name: "NodeJs",
//           iconifyClass: "logos-nodejs",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/rajmahadev8/Fin-Split",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devpost",
//           url: "https://devpost.com/software/finsplit",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//       ],
//     },
//     {
//       id: "4",
//       name: "Emosic",
//       url: "https://github.com/kevalvavaliya/Emosic",
//       description:
//         "An app that plays music according to your mood. Created a playlist management UI and used SpotifyAPI to control player client based on mood detection using ml model.",
//       languages: [
//         {
//           name: "HTML5",
//           iconifyClass: "logos-html-5",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "logos-css-3",
//         },
//         {
//           name: "Python",
//           iconifyClass: "logos-python",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/kevalvavaliya/Emosic",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devpost",
//           url: "https://devpost.com/software/emosic",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//       ],
//     },
//     {
//       id: "5",
//       name: "Fileblok",
//       url: "https://github.com/Thulax/Fileblok",
//       description:
//         "Keep your projects moving with seamless transfer experice. FileBlok is a file transfer app that allows you to transfer files from one device to another without any hassle. We built this app using Flutter, Node.js and StoryBlok.",
//       languages: [
//         {
//           name: "Flutter",
//           iconifyClass: "logos-flutter",
//         },
//         {
//           name: "NodeJs",
//           iconifyClass: "logos-nodejs",
//         },
//         {
//           name: "Storyblok",
//           iconifyClass: "logos-storyblok-icon",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/Fileblok",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Devpost",
//           url: "https://devpost.com/software/fileblok",
//           iconifyClass: "fluent:window-dev-edit-20-filled",
//         },
//       ],
//     },
//     {
//       id: "6",
//       name: "BAUDDIK-GEEKS PORTFOLIO",
//       url: "https://github.com/Bauddhik-Geeks/Bauddhik-Geeks.github.io",
//       description:
//         "Awesome Community Portfolio website for Bauddhik-Geeks community",
//       languages: [
//         {
//           name: "HTML5",
//           iconifyClass: "vscode-icons:file-type-html",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "vscode-icons:file-type-css",
//         },
//         {
//           name: "JavaScript",
//           iconifyClass: "logos-javascript",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Bauddhik-Geeks/Bauddhik-Geeks.github.io",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Live Demo",
//           url: "https://bauddhikgeeks.co/",
//           iconifyClass: "mdi:web",
//         },
//       ],
//     },
//     {
//       id: "7",
//       name: "Votechain",
//       url: "https://github.com/abhigoyani/votechain",
//       description:
//         "Awesome Community Portfolio website for Bauddhik-Geeks community",
//       languages: [
//         {
//           name: "Flask",
//           iconifyClass: "logos-flask",
//         },
//         {
//           name: "Python",
//           iconifyClass: "logos-python",
//         },
//         {
//           name: "HTML5",
//           iconifyClass: "logos-html-5",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "logos-css-3",
//         },
//         {
//           name: "MongoDB",
//           iconifyClass: "logos-mongodb-icon",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/abhigoyani/votechain",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "8",
//       name: "Swag Store",
//       url: "https://github.com/Thulax/e-commerce-frontend",
//       description:
//         "An E-commerce website built using MERN[Mongo, Express, React, Node] stack and we have also added stripe payment gateway integration [in test mode].",
//       languages: [
//         {
//           name: "ReactJS",
//           iconifyClass: "logos-react",
//         },
//         {
//           name: "NodeJS",
//           iconifyClass: "logos-nodejs",
//         },
//         {
//           name: "MedusaJS",
//           iconifyClass: "logos-medusa-icon",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/e-commerce-frontend",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "9",
//       name: "node-blockchain",
//       url: "https://github.com/Thulax/node-blockchain",
//       description:
//         "A simple blockchain and cryptocurrency wallet implemented in Node.js and TypeScript (for learning purposes).",
//       languages: [
//         {
//           name: "NodeJS",
//           iconifyClass: "logos-nodejs",
//         },
//         {
//           name: "TypeScript",
//           iconifyClass: "skill-icons:typescript",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/node-blockchain",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "10",
//       name: "Know Me Well",
//       url: "https://github.com/Thulax/personal-portfolio",
//       description:
//         "A simple command line interface based quiz app to know more about me :).",
//       languages: [
//         {
//           name: "JavaScript",
//           iconifyClass: "logos-javascript",
//         },
//         {
//           name: "NodeJS",
//           iconifyClass: "logos-nodejs",
//         },
//         {
//           name: "Repl.it",
//           iconifyClass: "logos-replit-icon",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/personal-portfolio",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "11",
//       name: "Bloggify",
//       url: "https://github.com/Thulax/Bloggify",
//       description: "A Simple REST API for Blog Application.",
//       languages: [
//         {
//           name: "NodeJS",
//           iconifyClass: "logos-nodejs",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/Bloggify",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "12",
//       name: "Stargazzers",
//       url: "https://github.com/Thulax/stargazers",
//       description: "An Unofficial API for GitHub Repo Stars Count",
//       languages: [
//         {
//           name: "NodeJs",
//           iconifyClass: "logos-nodejs",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/stargazers",
//           iconifyClass: "ri:github-fill",
//         },
//       ],
//     },
//     {
//       id: "13",
//       name: "GitHub Theme Portfolio",
//       url: "https://github.com/Thulax/Thulax.github.io",
//       description:
//         "A Personal Portfolio Website that showcases my work and experience. which is hosted on Github Pages.",
//       languages: [
//         {
//           name: "HTML5",
//           iconifyClass: "vscode-icons:file-type-html",
//         },
//         {
//           name: "CSS3",
//           iconifyClass: "vscode-icons:file-type-css",
//         },
//         {
//           name: "JavaScript",
//           iconifyClass: "logos-javascript",
//         },
//         {
//           name: "SCSS",
//           iconifyClass: "vscode-icons:file-type-scss2",
//         },
//       ],
//       links: [
//         {
//           name: "Github",
//           url: "https://github.com/Thulax/Thulax.github.io",
//           iconifyClass: "ri:github-fill",
//         },
//         {
//           name: "Live Demo",
//           url: "https://Thulax.github.io/",
//           iconifyClass: "mdi:web",
//         },
//       ],
//     },
    // {
    //   id: "6",
    //   name: "Automate Attendace",
    //   url: "https://github.com/Thulax/Node_Python",
    //   description: "Automation of Online Attendance using node js and python",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Devfolio",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "7",
    //   name: "Automate Discord Bot",
    //   url: "https://github.com/Thulax/AutomateDiscordBot",
    //   description:
    //     "A Discord Bot to send Automatic messages to serer channel in regular time difference.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Python Selenium",
    //       iconifyClass: "logos-selenium",
    //     },
    //     {
    //       name: "Chromium Browser",
    //       iconifyClass: "openmoji-chromium",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Devfolio",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "8",
    //   name: "Flask Blog",
    //   url: "https://github.com/Thulax/flask_blog",
    //   description: "A Simple Blog Web Application made using Flask Framework",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Devfolio",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "9",
    //   name: "Netflix top series",
    //   url: "https://github.com/Thulax/netflix-top-series",
    //   description: "List of Top Netflix Series which is deployed to vercel.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Devfolio",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "COVID-19 Tracker",
    //   url: "https://github.com/Thulax/Covid19TrackerReact",
    //   description:
    //     "Simple Covid-19 Tracker made using React and deployed to Vercel.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/Thulax/Covid19TrackerReact",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "11",
    //   name: "Food Order Static Website",
    //   url: "https://github.com/Thulax/food-order-website",
    //   description:
    //     "A simple static website related to food restaurants service. this is reasponsive as well.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "PHP",
    //       iconifyClass: "logos-php",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Devfolio",
    //       url: "",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "12",
    //   name: "NFT Launchpad",
    //   url: "https://deliquescent-cents.000webhostapp.com/",
    //   description: "NFT Launchpad crypto site portfolio",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/Thulax/nft-launchpad",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
//   ],
// };

export {
  certifications, contactPageData, degrees, experience, greeting, projects, projectsHeader, settings, skills, socialMediaLinks
};

